import $ from 'jquery';

const initToggleSearch = (el, overlayEl) => {
  const $toggler = $(el);
  const targetID = $toggler.data('target');
  const $searchBlock = $(`#${targetID}`);
  const $form = $searchBlock.find('form');
  const $overlay = $(overlayEl);
  const $abortButton = $('.form__abort-btn');
  const $searchButton = $('[data-drupal-selector="edit-submit-search-2"]');

  const fadingOut = (e) => {
    const { target } = e;

    $(target).css({ animation: '' });
    $(target).removeClass('is-open');

    $overlay.remove();

    $(target).off('animationend', fadingOut);
  };

  const focusInput = (e) => {
    const { target } = e;
    const input = $(target).find('input[type="text"');

    const stringLength = input.val() ? input.val().length : null;

    if (stringLength) {
      input.val('');
    }
    input.trigger('focus');

    $(target).off('animationstart', focusInput);
  };

  const handleUsingEscKey = (e) => {
    const key = e.key || e.keyCode;
    if (key === 27 || key === 'Escape') {
      const { closeSearch } = e.data;

      if (closeSearch) {
        closeSearch(e);
      }
    }
  };

  const closeSearch = (e) => {
    const { search, overlay } = e.data;

    search.css({ animation: 'fadeOut 200ms forwards 0ms' });
    search.attr('data-expanded', false);
    $overlay.removeClass(['is-open']);

    overlay.off('click', closeSearch);
    $('body').removeClass('overflow-hidden');

    search.on('animationend', fadingOut);
    $(document).off('keydown', handleUsingEscKey);
  };

  const openSearch = (search, form, overlay) => {
    const $resetButton = form.find('input[type="reset"]');

    if ($resetButton.length > 0) {
      $resetButton.attr('tabindex', '');
    }

    search.addClass('is-open');
    search.attr('data-expanded', true);

    search.on('animationstart', focusInput);
    $('body').addClass('overflow-hidden');

    setTimeout(() => {
      overlay.addClass(['is-open']);
    }, 100);

    overlay.on('click', { search, overlay }, closeSearch);
    $abortButton.on('click', { search, overlay }, closeSearch);
    $searchButton.on('click', { search, overlay }, closeSearch);
    $(document).on('keydown', { search, overlay, closeSearch }, handleUsingEscKey);

    $(document).ajaxComplete((event, xhr, settings) => {
      if (!settings.data || !settings.data.includes('view_name=search')) {
        return;
      }

      const e = {
        data: {
          search,
          overlay,
        },
      };

      closeSearch(e);
    });
  };

  if ($searchBlock && $form.length > 0) {
    $toggler.on('click keypress', () => {
      $('.site-container').append($overlay);
      openSearch($searchBlock, $form, $overlay);
    });
  }
};

const initSearch = (el) => {
  const $el = $(el);
  const $form = $el.find('form');

  const $resetButton = $('<button>', {
    type: 'button',
    class: ['btn', 'btn--icon-close', 'form__reset-btn', 'js-search-reset'].join(' '),
    'aria-label': 'Rensa sök',
    value: 'Rensa sök',
    tabindex: '-1',
  });

  if ($form.length > 0) {
    $form.append($resetButton);
    const textField = $form.find('input[type="text"]');

    $resetButton.on('click', () => {
      textField.val('');
      textField.trigger('focus');
    });
  }
};

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstToggleSearch = {
    attach(context) {
      const overlay = $('<div />', {
        class: ['overlay', 'overlay--search'].join(' '),
      });
      $('button[data-action="show-search"]', context).each((index, element) => initToggleSearch(element, overlay));
    },
  };
}(window, Drupal));

// eslint-disable-next-line func-names
(function (window, Drupal) {
  Drupal.behaviors.mstSearch = {
    attach(context) {
      $('.search-block', context).each((index, element) => initSearch(element));
    },
  };
}(window, Drupal));
